import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import Select, {SelectProps} from "@awsui/components-react/select";
import {OptionDefinition} from "@awsui/components-react/internal/components/option/interfaces";


interface StageSelectProps {
    setStage: Dispatch<SetStateAction<number>>;
    length: number | undefined;
    lastStage?: number | undefined;
}

const StageSelect: React.FC<StageSelectProps> = (props) => {

    const {t} = useTranslation("common");

    const allStagesOption: SelectProps.Option = {
        value: "-1",
        label: t("stages.all")
    };

    const generalStageOption: SelectProps.Option = {
        value: "0",
        label: t("stages.overall")
    };

    const stageOptions = (length: number): SelectProps.Option[] =>
        [allStagesOption].concat([...Array(length).keys()].map(value => ({
            value: `${value + 1}`,
            label: t("stages.stageN", {n: value + 1})
        }))).concat([generalStageOption]);

    const {lastStage, setStage, length} = props;

    const [selectedOption, setSelectedOption] = useState<SelectProps.Option>(lastStage !== undefined
        ? {
            value: `${lastStage + 1}`,
            label: t("stages.stageN", {n: lastStage + 1})
        } : allStagesOption);

    useEffect(() => {
        if (lastStage !== undefined) {
            setStage(lastStage + 1);
        }
    }, [lastStage, setStage]);

    const changeStage = (selected: OptionDefinition) => {
        setSelectedOption(selected);
        setStage(parseInt(selected.value || "0", 10));
    };

    return (
        <Select
            selectedOption={selectedOption}
            onChange={({detail}) => (
                changeStage(detail.selectedOption)
            )}
            options={stageOptions(length || 21)}
            selectedAriaLabel={t("common.selected")}
        />
    );
};

export default StageSelect;
